const ActionMovies = [
  {
    title: 'The Batman',
    img: 'batman.jpeg',
    synopsis: 'As a young vigilante, Bruce Wayne learns to trust new allies to take down his most vexing opponent yet, the illusive Riddler.',
    score: 8.3,
  },
  {
    title: 'Bullet Train',
    img: 'bullet_train.jpeg',
    synopsis: 'Five assassins aboard a swiftly-moving bullet train find out that their missions have something in common.',
    score: 7.3,
  },
  {
    title: 'Uncharted',
    img: 'uncharted.jpeg',
    synopsis: 'Street-smart Nathan Drake is recruited by seasoned treasure hunter Victor "Sully" Sullivan to recover a fortune amassed by Ferdinand Magellan, and lost 500 years ago by the House of Moncada.',
    score: 6.3,
  },
];

export default ActionMovies;
